import { render, staticRenderFns } from "./SampleModalKanbanTask.vue?vue&type=template&id=4363095d&scoped=true&"
import script from "./SampleModalKanbanTask.vue?vue&type=script&lang=js&"
export * from "./SampleModalKanbanTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363095d",
  null
  
)

export default component.exports